import React, { FC, useState, useContext } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';

import ErrorMessage from './ErrorMessage';
import LoadingWrapper from './LoadingWrapper';

import { DeleteConfirmationModalContext } from '../contexts/DeleteConfirmationModalContext';

import axios from '../utils/axios.utils';

interface DeleteConfirmationModalProps {
  refetchParentRecord?: () => void;
}

const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = (props) => {
  let { refetchParentRecord } = props;

  let {
    additionalParams,
    modelLabel,
    deleteURL,
    deleteConfirmationModalOpen,
    setDeleteConfirmationModalOpen,
    recordToDelete,
  } = useContext(DeleteConfirmationModalContext);

  let [errorMessage, setErrorMessage] = useState<string>('');
  let [loading, setLoading] = useState<boolean>(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await axios.delete(`/${deleteURL}/${recordToDelete.id}`, { params: additionalParams });
      refetchParentRecord();
      setDeleteConfirmationModalOpen(false);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={deleteConfirmationModalOpen} onClose={() => setDeleteConfirmationModalOpen(false)}>
      <LoadingWrapper isLoading={loading}>
        <Grid container spacing={2} style={{ minWidth: '400px', padding: '30px' }}>
          <Grid item xs={12}>
            <Typography variant="h5">Delete {modelLabel}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6">Are you sure you want to delete this {modelLabel}?</Typography>
          </Grid>
          <Grid item xs={12}>
            <ErrorMessage message={errorMessage} />
          </Grid>
          <Grid item xs={3}>
            <Button variant="contained" onClick={handleDelete} color="warning">
              Delete
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button variant="contained" onClick={() => setDeleteConfirmationModalOpen(false)} color="secondary">
              Cancel
            </Button>
          </Grid>
        </Grid>
      </LoadingWrapper>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
